<template>
  <div class="fileinput text-center col-12">
    <div>
      <canvas v-show="false" id="canvas" width="1000"></canvas>
    </div>
    <div>
      <span class="btn btn-primary btn-simple btn-file" :class="fileExists ? 'col-9' : 'col-12'">
        <span class="fileinput-new">
          {{ fileExists ? fileName : selectText }}
        </span>
        <input :accept="accept" @change="handlePreview" type="file" name="..." class="valid" :multiple="false"
          aria-invalid="false" />
      </span>

      <base-button v-if="fileExists" @click="removeFile" type="danger" class="col-2">
        <i class="fas fa-times"></i>
      </base-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "file-upload",
  props: {
    selectText: {
      type: String,
      default: "Select image",
    },
    accept: {
      type: String,
      default: "image/*, application/pdf",
    },
  },
  data() {
    return {
      fileName: "",
    };
  },
  computed: {
    fileExists() {
      return this.fileName !== "" && this.fileName !== null;
    },
  },
  methods: {
    handlePreview(event) {
      let file = event.target.files[0];
      this.fileName = file.name;

      let that = this;

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        that.$emit("change", reader.result);
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },
    removeFile() {
      this.fileName = null;
      this.$emit("change", null);
    },
  },
};
</script>
<style>

</style>
